export default __webpack_public_path__ + "static/media/bghero1.1afd2555.png";